import { api_POSTFiles, api_GET, api_POST } from "api/_axios.js";

const drecomissoesreembolso_api =
{
    uploadEspelhoComissaoReembolso: function (mesAno, espelhoComissao, espelhoReembolso) {
        const promise = new Promise((resolve, reject) => {
            api_POSTFiles(`DREEspelhoComissoesReembolso/uploadEspelhoComissaoReembolso/${mesAno}`, espelhoComissao, espelhoReembolso).then(result => {
                resolve(result)
            });
        });
        return promise;
    },
    processamentos() {
        return api_GET("DREEspelhoComissoesReembolso/processamentos");
    },
    cancelarProcessamento(id) {
        return api_POST(`DREEspelhoComissoesReembolso/cancelarProcessamento/${id}`);
    }
}

export default drecomissoesreembolso_api
